module.exports = "/images/dwiz.png?80978c2471ea92163059dd0d563e40bf";